// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';
import { Flex } from '../../../../components/Flex';

export const DocumentDetailContainer = styled(Flex)`
  position: relative;

  overflow: visible;

  flex: 1;

  padding-bottom: 20px;
  width: 100%;
`;

export const ScrollTarget = styled.div`
  position: relative;
  top: -150px;
`;
